var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isTableLoading,
                  expression: "isTableLoading",
                },
              ],
              staticStyle: { "margin-top": "10px" },
            },
            [
              _c("avue-form", {
                ref: "form_ts",
                attrs: {
                  option: _vm.optionData,
                  "upload-error": _vm.handleUploadError,
                },
                scopedSlots: _vm._u([
                  {
                    key: "crmListStr",
                    fn: function (ref) {
                      var size = ref.size
                      return [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.formData.crmListStr),
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "label",
                    fn: function (ref) {
                      var size = ref.size
                      return [
                        _vm.riskList && _vm.riskList.length > 0
                          ? _c(
                              "div",
                              _vm._l(_vm.riskList, function (item, index) {
                                return _c("MbLabel", {
                                  key: index,
                                  attrs: {
                                    category: item.category,
                                    weight: item.STRONG,
                                    isDept: item.deptId != 0,
                                    labelName: item.name,
                                    icon: item.icon || "",
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "settlePerson",
                    fn: function (ref) {
                      var size = ref.size
                      return [
                        _vm.formData.settleType && _vm.settleInfoList.length > 0
                          ? _c("div", {
                              staticClass: "divide",
                              staticStyle: { "margin-bottom": "15px" },
                            })
                          : _vm._e(),
                        _vm._l(_vm.settleInfoList, function (item, index) {
                          return _c(
                            "avue-form",
                            {
                              key: index,
                              ref: "form_ts_person",
                              refInFor: true,
                              attrs: { option: _vm.settleInfoOption },
                              model: {
                                value: _vm.settleInfoList[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.settleInfoList, index, $$v)
                                },
                                expression: "settleInfoList[index]",
                              },
                            },
                            [
                              _c("template", {
                                staticStyle: { height: "0 !important" },
                                slot: "menuForm",
                              }),
                              _c(
                                "template",
                                { slot: "del" },
                                [
                                  !_vm.isSettleAgent
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            icon: "el-icon-minus",
                                            type: "info",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDel(index)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        }),
                        !_vm.isSettleAgent && !_vm.isView
                          ? _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "margin-left": "110px",
                                  "margin-bottom": "15px",
                                },
                                attrs: {
                                  disabled:
                                    !_vm.isSettlePrivate &&
                                    _vm.settleInfoList.length > 0,
                                  size: size,
                                  icon: "el-icon-plus",
                                  type: "primary",
                                },
                                on: { click: _vm.initSettleData },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.isSettlePrivate
                                        ? "新增结算人"
                                        : "新增结算企业"
                                    ) +
                                    "\n\t\t\t\t\t"
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.formData.settleType && _vm.settleInfoList.length > 0
                          ? _c("div", { staticClass: "divide" })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.formData,
                  callback: function ($$v) {
                    _vm.formData = $$v
                  },
                  expression: "formData",
                },
              }),
              _c(
                "el-row",
                {
                  staticStyle: { padding: "10px" },
                  attrs: { justify: "center", type: "flex" },
                },
                [
                  _vm.isView
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.isSubLoading,
                            type: "primary",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onDisableEdit(false)
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\t编辑\n\t\t\t\t")]
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: { loading: _vm.isSubLoading, type: "primary" },
                          on: { click: _vm.onCommitHint },
                        },
                        [_vm._v("提交")]
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "特殊客户来源数据选择",
                visible: _vm.searchCrmCustomerFlag,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.searchCrmCustomerFlag = $event
                },
              },
            },
            [
              _c("originChannelIdList", {
                attrs: { channel: _vm.formData },
                on: { chooseChannelId: _vm.chooseChannelId },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.searchCrmCustomerFlag = false
                        },
                      },
                    },
                    [_vm._v("关 闭")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "客户线索选择",
                visible: _vm.chooseClueFlag,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.chooseClueFlag = $event
                },
              },
            },
            [
              _c("clueIdList", {
                attrs: { channel: _vm.formData },
                on: { chooseClue: _vm.chooseClue },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.chooseClueFlag = false
                        },
                      },
                    },
                    [_vm._v("关 闭")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }